import React, { useState } from 'react'
import PropTypes from 'prop-types'

import UnmissableStyles from './unmissable-styles'
import { Container, Grid } from '@material-ui/core'
import globalStyles from '../styles/global-styles.module.scss'
import UnmissableCard from './cards/unmissable'
import ListingStyles from './blog/listing-styles'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const Unmissable = (props) => {
  const [showMore, setShowMore] = useState(false)
  const classes = UnmissableStyles({})
  const listingStyles = ListingStyles({ columns: 1 })
  const { data } = props
  const { t, i18n } = useTranslation('common')
  const router = useRouter()

  return (
    <>
      <Container maxWidth={'lg'}>
        <Grid container spacing={3} justify={'center'}>
          <Grid item xs={12}>
            <h3
              className={`${globalStyles.sectionHeading} ${globalStyles.centered}`}
              style={{ marginBottom: '24px' }}
            >
              <span className={globalStyles.tag}>{data[`tag`]}</span>
              {data[`heading`]}
            </h3>
          </Grid>
          <Grid item container spacing={3} xs={12} className={classes.root}>
            {data.card.map((card, i) => (
              <React.Fragment key={i}>
                <Grid item xs={12} sm={6} md={3}>
                  <UnmissableCard destination={card} key={i} />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
Unmissable.propTypes = {
  data: PropTypes.object.isRequired,
}
export default Unmissable
